import type { CompanyData } from "./types";

export const zenitova: CompanyData = {
  slug: "zenitova",
  title: "ZENİTOVA İLERİ TEKNOLOJİ ARAŞTIRMA GELİŞTİRME VE DANIŞMANLIK MERKEZİ ANONİM ŞİRKETİ",

  billFileNameRegexList: [
    /zenitova[-_]electroop/ig
  ],

  transferDescriptionRegexList: [
    /electroop/ig
  ],

  taxNo: "9971843525",
  taxOffice: "Zincirlikuyu",

  address: "ESENTEPE MAH. TALAT PAŞA CAD. No:5 Kapı No:1 Şişli/ İstanbul / Türkiye",
  bankInfo: `ZENİTOVA İLERİ TEKNOLOJİ ARAŞTIRMA GELİŞTİRME VE DANIŞMANLIK MERKEZİ ANONİM ŞİRKETİ
IBAN: TR410006701000000034532427`,
  
  registryId: "0997184352500001",
  website: "https://zenitova.com",
}